import { isOrderCouponApplied, type Order } from '@src/domains/orders';
import { shouldShowServiceFee } from '@src/domains/service-fees';
import { getOrderDiscountCents } from '@src/features/orders/summary/core/orderCouponSummary';
import { summaryHasDetails } from '@src/features/transactables/summary/core/summaryHasDetails';

export const orderSummaryHasDetails = (order: Order | null | undefined, serviceFeeFeatureEnabled: boolean): boolean =>
  summaryHasDetails({
    discountCents: getOrderDiscountCents(order),
    isCouponApplied: isOrderCouponApplied(order),
    showServiceFee: shouldShowServiceFee(order?.serviceFeeCurrencyInfo?.amountCents, serviceFeeFeatureEnabled),
  });
